export const PressController = {
    index(): void {},
};
